import styled from 'styled-components'
import {Marginals} from '../../styles'

export const Footer = styled.footer`
  ${Marginals}

  bottom: 0;

  padding: 1rem;

  justify-content: space-around;
`
export const H2 = styled.h2.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  font-size: 3em;
  font-weight: bolder;
  line-height: 0.7;

  margin: 1vh 5vw;
  padding: 0.25em;

  text-align: center;
`

export const H2Middle = styled(H2).attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  position: relative;

  flex-grow: 1;

  text-align: center;

  &::after {
    content: '';

    background-color: ${(props) => props.textColor};

    position: absolute;
    display: block;
    height: 0.1rem;
    left: 1.2rem;
    right: 1.2rem;
    top: 55%;
  }
`
